import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import FetchServerData from "../../../provider/FetchServerData";
import Utils from "../../../provider/Utils";
import Map from "../../givBee/map/Map";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import Footer from "../home/Footer";
import givBeeLogo from "../home/assets/img/givbeeLogo.png";
import "./ContactUs.css";
import { Col, Row } from "reactstrap";
import Button from "@material-ui/core/Button";
import Header from "../home/Header";
class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      email: "",
      name: "",
      phone: "",
      phoneNumber: "",
      comment: "",
      message: "",
      subject: "",
      companyName: "",
      addressObj: {
        line: "295 Seven Farms Drive",
        city: "Charleston",
        country: "USA",
        state: "South Carolina",
      },
    };
    this.showMap();
  }
  async showMap() {
    let address = [];
    address.push(this.state.addressObj);
    let locaData1 = [];
    for (let i = 0; i < address.length; i++) {
      let locdata = await Utils.getLatLongMapData(
        address[i].line,
        address[i].city,
        address[i].country,
        address[i].state,
        i
      );
      locaData1.push(locdata);
      this.setState({ history: locaData1 });
    }
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handleNameChange(e) {
    this.setState({ name: e.target.value });
  }
  handleCompanyNameChange(e) {
    this.setState({ companyName: e.target.value });
  }
  handlePhoneChange(e) {
    // this.setState({ phone: e.target.value });
    let val = e.target.value;
    // if (val.length <= 12) {
    //   let value = Utils.phoneNumberFormate(val);
    //   this.setState({
    //     phoneNo: value,
    //     phone: e.target.value.replace(/-/g, ""),
    //   });
    // }
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);

      this.setState({
        phone: value,
        phoneNumber: e.target.value.replace(/-/g, ""),
      });
    }
  }
  handleSubjectChange(e) {
    this.setState({ subject: e.target.value });
  }
  handleCommentChange(e) {
    this.setState({ comment: e.target.value });
  }
  addContactToBackend(e) {
    const postObject = {
      name: this.state.name,
      email: this.state.email,
      companyName: this.state.companyName,
      message: this.state.comment,
      phone: this.state.phoneNumber,
      subject: this.state.subject,
    };
    FetchServerData.callPostService("/enquiryms/sendEnquiry", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);

          this.setState({
            email: "",
            name: "",
            phone: "",
            comment: "",
            companyName: "",
            message: "",
            subject: "",
          });
        } else {
        }
      }
    );
  }

  getMapView(locations) {
    return <Map data={locations}></Map>;
  }
  render() {
    return (
      <>
        <Header />

        <section id="contact" className="contact">
          <div className="container" style={{ padding: "0em 8em" }}>
            <div className="section-title" data-aos="fade-up">
              <h2>Contact Us</h2>
            </div>
            <div className="row">
              <div className="contact-about">
                <div className="logo">
                  <img
                    src={givBeeLogo}
                    alt=""
                    style={{
                      width: "auto",
                      height: "50px",
                      marginTop: "-1em",
                    }}
                  />
                </div>
                <p style={{ marginTop: "1em", color: "#000" }}>
                  To talk about your use case or to schedule a demo, call us at
                  (844) 407-1996.
                </p>
              </div>
              <div
                className="col-md-7"
                data-aos="fade-up"
                data-aos-delay={300}
                style={{ padding: "1em" }}
              >
                <ValidatorForm
                  ref="form"
                  onSubmit={this.addContactToBackend.bind(this)}
                >
                  <div className="row form-group">
                    <div className="col-md-6">
                      <label
                        className="form-label"
                        htmlFor="multiStepsFirstName"
                      >
                        Name*
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.name}
                        onChange={this.handleNameChange.bind(this)}
                        placeholder="Your Name"
                        required
                        title=""
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        className="form-label"
                        htmlFor="multiStepsFirstName"
                      >
                        Email*
                      </label>
                      <input
                        type="email"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        placeholder="Your Email"
                        required
                        title=""
                        value={this.state.email}
                        onChange={this.handleEmailChange.bind(this)}
                      />
                    </div>
                  </div>
                  <div className="row form-group" style={{ marginTop: "1em" }}>
                    <div className="col-md-6">
                      <label
                        className="form-label"
                        htmlFor="multiStepsFirstName"
                      >
                        Phone*
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.phone}
                        onChange={this.handlePhoneChange.bind(this)}
                        placeholder="Your Phone"
                        required
                        title=""
                      />
                    </div>
                    <div className="col-md-6">
                      <label
                        className="form-label"
                        htmlFor="multiStepsFirstName"
                      >
                        Company
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        value={this.state.companyName}
                        onChange={this.handleCompanyNameChange.bind(this)}
                        placeholder="Your Company"
                      />
                    </div>
                  </div>
                  <div className="form-group" style={{ marginTop: "1em" }}>
                    <label className="form-label" htmlFor="multiStepsFirstName">
                      Subject*
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      id="multiStepsFirstName"
                      name="multiStepsFirstName"
                      className="form-control"
                      value={this.state.subject}
                      onChange={this.handleSubjectChange.bind(this)}
                      placeholder="Subject"
                      required
                      title=""
                    />
                  </div>
                  <div className="form-group" style={{ marginTop: "1em" }}>
                    <label className="form-label" htmlFor="multiStepsFirstName">
                      Message*
                    </label>
                    <textarea
                      autoComplete="off"
                      id="multiStepsFirstName"
                      name="multiStepsFirstName"
                      className="form-control"
                      rows={5}
                      value={this.state.comment}
                      onChange={this.handleCommentChange.bind(this)}
                      placeholder="Comment or Message"
                      required
                      title=""
                      defaultValue={""}
                    />
                  </div >

                  <div className="text-center" style={{ marginTop: "1em" }}>
                    <Button
                      type="submit"
                      style={{
                        background: "gray",
                        // borderRadius: "50px",
                        padding: "6px 15px",
                        border: "none",
                        color: "#fff",
                      }}
                    >
                      Send Message
                    </Button>
                  </div>
                </ValidatorForm >
              </div >
              <div
                className="col-md-5 mt-3"
                data-aos="fade-up"
                data-aos-delay={100}
              >
                <Row>
                  <Col md={12}>
                    <div style={{ height: "28em", position: "relative" }}>
                      <Map data={this.state.history} />
                    </div>
                  </Col>
                </Row>
              </div>
            </div >
          </div >
        </section >
        <Footer />
      </>
    );
  }
}

export default ContactUs;
